import { useEffect, useState } from 'react';
import { billingApi, type ModuleLicense } from '../../api/billing';

export function LicenseManagerPage() {
  const [licenses, setLicenses] = useState<ModuleLicense[]>([]);
  const [moduleId, setModuleId] = useState('crm');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const refresh = () => {
    void billingApi.listModuleLicenses().then(setLicenses).catch((e) => setError(String(e)));
  };

  useEffect(refresh, []);

  const activate = async () => {
    setBusy(true);
    setError('');
    try {
      await billingApi.activateModuleLicense({ module_id: moduleId, bundle_code: 'professional' });
      refresh();
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">License Manager</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Module and feature licensing governed by the commercial engine.</p>
      <div className="mt-4 flex gap-2">
        <input className="rounded border px-2 py-1 text-sm dark:border-slate-700 dark:bg-slate-900" value={moduleId} onChange={(e) => setModuleId(e.target.value)} />
        <button type="button" disabled={busy} className="rounded bg-slate-900 px-3 py-1 text-sm text-white dark:bg-slate-100 dark:text-slate-900" onClick={activate}>Activate</button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {licenses.map((l) => (
          <div key={l.id} className="flex items-center justify-between rounded-xl border px-4 py-3 dark:border-slate-700">
            <div>
              <p className="font-medium">{l.module_id}</p>
              <p className="text-xs text-slate-500">{l.license_key}</p>
            </div>
            <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs dark:bg-slate-800">{l.status}</span>
          </div>
        ))}
        {licenses.length === 0 && <p className="text-sm text-slate-500">No module licenses yet.</p>}
      </div>
    </div>
  );
}
